import api from "../store/services/api";

const MerchantsService = {
  getMerchants: (params) => {
    return api.get("/merchant/", { params });
  },
  getMerchantsReportData: (params) => {
    return api.get("/new/merchant-data/", { params });
  },
  getMerchantsIfoodImport: (params) => {
    return api.get("/iFood/import/catalog/", { params });
  },
  createMerchantsIfoodImport: (item) => {
    return api.post("/iFood/import/catalog/", item, {
      headers: { "Content-Type": "application/json" },
    });
  },
  createMerchant: (merchant) => {
    return api.post("/merchant/", merchant, {
      headers: { "Content-Type": "application/json" },
    });
  },
  editMerchant: (merchant, merchantId) => {
    return api.put(`/merchant/?rid=${merchantId}`, merchant, {
      headers: { "Content-Type": "application/json" },
    });
  },
  deleteMerchant: (merchantId) => {
    return api.delete(`/merchant/?rid=${merchantId}`);
  },
};

export default MerchantsService;
